import { notifUtils } from "../components/NotifUtils/NotifUtils";
import { handleError } from "../components/Utils/Utils";
import InvoiceService from "../Services/InvoiceService";

export const getInvoiceList = (store, value, refresh) => {
  const isLoading = !store.state.isLoading;
  const status = 200;
  let invoices = store.state.invoices;
  if (refresh) {
    invoices = [];
  }
  store.setState({ isLoading, status, invoices });

  return InvoiceService.getInvoiceList(value)
    .then((response) => {
      let data = response.data;
      const isLoading = false;
      const status = response.status;
      store.state.lastPage = false;
      store.state.invoices = refresh ? data : store.state.invoices.concat(data);
      if (data.length < parseInt(value.num)) {
        store.state.lastPage = true;
      }
      store.setState({
        isLoading,
        header: response.headers,
        status,
      });
    })
    .catch((error) => {
      handleError(error);
    });
};

export const getInvoiceSummary = (store, value, refresh) => {
  const status = 200;
  store.setState({ status });

  return InvoiceService.getInvoiceSummary(value)
    .then((response) => {
      let data = response.data;
      const isLoading = false;
      const status = response.status;
      store.state.invoiceSummary = data;
      store.setState({
        isLoading,
        header: response.headers,
        status,
      });
    })
    .catch((error) => {
      handleError(error);
    });
};

export const patchInvoiceSettled = async (store, id, params, notif) => {
  try {
    const response = await InvoiceService.patchInvoiceSettled(id, params);
    const data = response.data;
    notifUtils(notif, "success");
    return data;
  } catch (error) {
    handleError(error);
    return error;
  }
};

export const getTotalSaldo = async (store) => {
  const status = 200;
  const isLoading = true;
  store.setState({ status, isLoading });

  return InvoiceService.getTotalSaldo()
    .then((response) => {
      store.state.saldo = response.data;
      const isLoading = false;
      const status = 200;
      store.setState({
        isLoading,
        header: response.headers,
        status,
      });
    })
    .catch((error) => {
      handleError(error);
    });
}

export const getInvoiceHistoryList = (store, value, prevTabActive) => {
  const isLoadingHistory = !store.state.isLoadingHistory;
  const status = 200;
  let historys = store.state.historys;
  const refresh = !prevTabActive;
  if (refresh) {
    historys = [];
  }
  store.setState({ isLoadingHistory, status, historys, refresh });

  return InvoiceService.getInvoiceHistoryList(value)
    .then((response) => {
      let data = response.data;
      const isLoadingHistory = false;
      const status = response.status;
      store.state.lastPage = false;
      store.state.historys = prevTabActive ? store.state.historys.concat(data) : data;

      if (data.length < parseInt(value.num)) {
        store.state.lastPage = true;
      }
      store.setState({
        isLoadingHistory,
        header: response.headers,
        status,
        refresh: false,
      });
    })
    .catch((error) => {
      handleError(error);
    });
};
